import React from 'react';
import { VictoryStack, VictoryBar, VictoryLabel } from 'victory';

const HorizontalStackChart = ({ primaryColor, secondaryColor, padding, data,
                                maxValue, yLabelFormatter = (datum) => datum.y}) => {
  const labelStyle = {
    fill: '#ffffff',
    fontSize: 14,
    fontWeight: 'bold'
  };

  const paddingSettings = {
    left: 0,
    top: 50,
    bottom: 50
  };

  const maxDomainValue = maxValue || Math.max(...data.map((item) => item.y));
  const mainData = data.map((item) => ({ ...item, width: 18 }));
  const fillerData = data.map((item) => ({ ...item, y: maxDomainValue - item.y, width: 18 }));

  return (
    <VictoryStack horizontal colorScale={[primaryColor, '#d3d3d3']} style={{labels: labelStyle}}
                  padding={padding || paddingSettings} height={50 + mainData.length * 45}>
      <VictoryBar labels={(d) => d.x} data={mainData} style={{labels: {fill: secondaryColor}}}
                  labelComponent={<VictoryLabel x={0} dy={-18} textAnchor="start"/>} />
      <VictoryBar labels={(d) => yLabelFormatter({y: maxDomainValue - d.y})} data={fillerData}
                  labelComponent={<VictoryLabel dx={-14} textAnchor="end"/>} />
    </VictoryStack>
  );
};

export default HorizontalStackChart;



// WEBPACK FOOTER //
// ./src/components/charts/horizontalStackChart.js